export const MESSAGE_PROVIDER_WEBCHAT = 6;
export const MESSAGE_PROVIDER_WHATSAPP = 2;